/**
 * Extracts the first 5 characters from a correlationId (GUID) to create a short request identifier.
 * This matches the format used in email notifications.
 * @param correlationId - The full GUID correlation ID
 * @returns A 5-character uppercase identifier (e.g., "A1B2C")
 */
export function getShortRequestId(correlationId: string): string {
  return correlationId.replace(/-/g, '').substring(0, 5).toUpperCase();
}
